import { ForwardedRef, forwardRef } from "react";
import { styled } from "styled-components";
import { TextInput } from "./TextInput";

type Props = {
  setPhoneNumber: (_number: string) => void;
  phoneNumber: string;
  setPhoneCountry: (_country: string) => void;
  phoneCountry: string;
  error?: string;
  onBlur?: () => void;
  id?: string;
  numberPlaceholder?: string;
};

export const PhoneNumberInput = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLInputElement>) => {
    const handleChange = (value: string) => {
      // replace all non-numeric characters
      value = value.replace(/\D/g, "");

      props.setPhoneNumber(value);
    };

    const handleChangeCountryCode = (value: string) => {
      value = "+" + value.replace(/[^0-9]/g, "");
      if (value.length > 5) {
        value = value.substring(0, 5);
      }
      props.setPhoneCountry(value);
    };

    const transformNumber = (number: string) => {
      // remove trailing zero
      if (number[0] === "0") {
        props.setPhoneNumber(number.substring(1));
      }
    };

    return (
      <Container id={props.id}>
        <TextInput
          value={props.phoneCountry}
          onChange={handleChangeCountryCode}
          placeholder="+49"
          style={{ flex: 1 }}
          inputMode="tel"
          autoComplete="tel-country-code"
        />
        <TextInput
          ref={ref}
          value={props.phoneNumber}
          onChange={handleChange}
          placeholder={props.numberPlaceholder ?? "17612345678"}
          onBlur={() => transformNumber(props.phoneNumber)}
          style={{ flex: 4 }}
          error={props.error}
          inputMode="tel"
          autoComplete="tel-local"
        />
      </Container>
    );
  },
);
PhoneNumberInput.displayName = "PhoneNumberInput";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;
